import piczoom from "vue-piczoom"
window.Vue.component("pic-zoom",piczoom)